import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { LoginComponent } from "./login/login.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "installation-management",
        loadChildren: () =>
          import("./screens/installation-management/installation-management.module").then(
            (m) => m.InstallationManagementModule,
          ),
      },
      {
        path: "process-management",
        loadChildren: () =>
          import("./screens/process-management/process-management.module").then(
            (m) => m.ProcessManagementModule,
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "login",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
